import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function LoanFAQ({
  badge,
  title,
  description,
  items = [],
}) {
  return (
    <section id="faq" className="py-20 bg-slate-50">
      <div className="container mx-auto px-6">

        <div className="max-w-3xl mx-auto text-center">

          {badge && (
            <span className="text-primary font-semibold uppercase tracking-wider">
              {badge}
            </span>
          )}

          <h2 className="mt-3 text-3xl md:text-4xl font-bold">
            {title}
          </h2>

          <p className="mt-5 text-lg text-slate-600 leading-8">
            {description}
          </p>

        </div>

        <div className="max-w-4xl mx-auto mt-14">

          <Accordion
            type="single"
            collapsible
            className="w-full"
          >
            {items.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
              >
                <AccordionTrigger className="text-left text-lg">
                  {faq.question}
                </AccordionTrigger>

                <AccordionContent className="text-slate-600 leading-7">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

        </div>

      </div>
    </section>
  );
}